import type FormEngine from "../FormEngine";

export default {
  sectionClose: function (this: FormEngine, section: any) {
    if (!section.state.skipValidation) {
      section.validate();
    } else {
      section.state.skipValidation = false;
    }
  },
};
